module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marc Olden\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marc Olden (1933–2003) was the author of forty mystery and suspense novels. Born in Baltimore, he began writing while working in New York as a Broadway publicist. His first book, "), _c('I', [_vm._v("Angela Davis")]), _vm._v(" (1973), was a nonfiction study of the controversial Black Panther. In 1973 he also published "), _c('I', [_vm._v("Narc")]), _vm._v(", under the name Robert Hawke, beginning a hard-boiled nine-book series about a federal narcotics agent."), _c('P', [_vm._v("A year later, "), _c('I', [_vm._v("Black Samurai")]), _vm._v(" introduced Robert Sand, a martial arts expert who becomes the first non-Japanese student of a samurai master. Based on Olden’s own interest in martial arts, which led him to the advanced ranks of karate and aikido, the novel spawned a successful eight-book series. Olden continued writing for the next three decades, often drawing on his fascination with Japanese culture and history. ")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14waOAK/tc-custom/9781453260746.jpg?1726617321233",
      "alt": "This image is the cover for the book Beauty Kill, The Narc Series"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beauty Kill, The Narc Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("On the verge of death from two gunshot wounds, Bolt vows revenge")])]), _c('p', {
    staticClass: "MsoNormal"
  }, [_vm._v("They call him Black Beauty, because he is the most gorgeous thief the drug world has ever seen. Where some are content to make a living ripping off dime-bag hustlers, Black Beauty steals from big-time dealers, taking profits from international cartels to keep himself rich, well-dressed, and smiling. His latest score netted him $850,000, along with the twenty-two kilos of cocaine the money was intended to buy. To get it he killed four men, and left one narcotics agent to bleed to death in a parking lot. Before long, Black Beauty will wish he finished the job. ")]), _c('p', {
    staticClass: "MsoNormal"
  }), _c('p', {
    staticClass: "MsoNormal"
  }, [_vm._v("John Bolt is too tough to let a pretty boy kill him. As soon as he’s strong enough to lift a .45, he’s coming after Black Beauty—even if he has to take vengeance from a wheelchair.  ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0